import React, { useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@a-ui/react';
import { openModal } from '../../store/slices/modalReducer'
import { selectTask } from '../../store/slices/tasksReducer'
import { getAvailableActions } from '../../helpers/task.helper';

import '../../styles/flyout.scss';

const TaskFlyout = (props) => {
  const [loading, setLoading]  = useState(false);
  const dispatch = useDispatch()
  const { task } = props;
  const { user } = useSelector(state => state.user);
  const { domains } = useSelector(state => state.domains);

  const domainForTask = domains.find((domain) => String(domain.id) === String(task?.domainId));
  const multipleTimeRegistrationsPerTaskActive = domainForTask?.multipleTimeRegistrationsPerTaskActive === true;

  const actions = getAvailableActions(task, user, loading, setLoading, dispatch, multipleTimeRegistrationsPerTaskActive);
  const { start, pause, complete } = actions;

  return <div className="actionsflyout">
    <ul className="a-checkbox-list a-checkbox-list--flushed">
      { start.visible && <li className="a-checkbox-list__item">
        <Button
          className="a-button a-button--text"
          addOn={{
            type: "icon",
            align: "left",
            iconProps: {
              name: "ai-controls-play",
            },
          }}
          type="primary"
          size="medium"
          onClick={() => start.action(task.id, task).then(() => {
            if( typeof props.onAction == "function" ) props.onAction();
          })}
        >
          Taak starten
        </Button>
      </li> }
      { pause.visible && <li className="a-checkbox-list__item">
        <Button
          className="a-button a-button--text"
          addOn={{
            type: "icon",
            align: "left",
            iconProps: {
              name: "ai-controls-pause",
            },
          }}
          type="primary"
          size="medium"
          onClick={() => pause.action(task.id).then(() => {
            if( typeof props.onAction == "function" ) props.onAction();
          })}
        >
          Taak pauzeren
        </Button>
      </li> }
      <li className="a-checkbox-list__item">
        <Button
          className="a-button a-button--text a-button--success"
          addOn={{
              type: "icon",
              align: "left",
              iconProps: {
                name: "ai-check-1",
              },
          }}
          type="primary"
          size="medium"
          onClick={() => complete.action(task.id, task).then(() => {
            if( typeof props.onAction == "function" ) props.onAction();
          })}
        >
       Taak voltooien
      </Button>
      </li>
      <li className="a-checkbox-list__item">
        <Button
        className="a-button a-button--text a-button--danger"
        iconRight="ai-remove"
        type="primary"
        addOn={{
            type: "icon",
            align: "left",
            iconProps: {
              name: "ai-controls-stop",
            },
        }}
        size="medium"
        onClick={() => {
          dispatch(selectTask(props.task.id));
          dispatch(openModal('CancelTask'))
          if( typeof props.onAction == "function" ) props.onAction();
        }}
      >
       Taak afbreken
      </Button>
      </li>
    </ul>
  </div>
}

export default TaskFlyout;
